enum ElementId {
  BackgroundOverlay = "BackgroundOverlay",
  Collection = "collection",
  Faqs = "faqs",
  Rarity = "rarity",
  Roadmap = "journey",
}

export default ElementId;
